import { newPricesStore, PricesState, PricesStore } from '@/scopes/prices/infrastructure/store'

import { identity } from 'ramda'
import { useStore } from 'zustand'

export function usePricesSelector<T, A extends unknown[] = []>(selector: (state: PricesState, ...args: A) => T, ...args: A): T {
  const store = useStore(newPricesStore, identity<PricesStore>)
  return selector(store, ...args)
}
